import { Periodicidade } from 'common/genericTypes';

export interface MultaMoraFieldsInterface {
  percentualMulta?: number;
  periodicidadeMulta?: Periodicidade;
  percentualMora?: number;
  periodicidadeMora?: Periodicidade;
}

export const multaMoraFieldsInitialState: MultaMoraFieldsInterface = {
  percentualMulta: undefined,
  periodicidadeMulta: undefined,
  percentualMora: undefined,
  periodicidadeMora: undefined,
};
